import { Button, Center, Flex, Heading, Link, Text } from "@chakra-ui/react";
import React from "react";
import { Link as ReactLink } from "react-router-dom";


export default function NotFound() {


    return (
        <Center bg={"white"} minH={"75vh"} color="black" rounded={20} m={[0, 10]} boxShadow={40}>
            <Flex flexDir={"column"}>
                <Flex mb={2} flexDir={"column"} alignItems={"center"} alignContent={"center"}>
                    {/*<Icon as={GoAlert} color={"#169499"} fontSize={"8xl"} />*/}
                    <Heading fontSize={"200px"} color={"#169499"}>404</Heading>
                </Flex>
                <Flex flexDir={"column"} alignItems={"center"} textAlign={"center"} mb={5}>
                    {/*<Heading color={"green.700"} fontSize={60}>Ops!</Heading>*/}
                    <Text mt={2} textAlign={"center"} fontSize={["xl", "2xl"]}>A página que você buscou não existe</Text>
                </Flex>
                <Link

                    as={ReactLink}
                    to={"/"} _hover={{ textDecoration: "none" }} w={"100%"}>
                    <Button px={16} mt={["5", "0"]} w={["100%", "100%"]} size="md" backgroundColor="#169499" colorScheme="teal">
                        Voltar para página inicial
                    </Button>
                </Link>
            </Flex>
        </Center>
    )
}